var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loaded)?[_c('div',{staticStyle:{"width":"100%","height":"100%","position":"absolute","display":"flex","justify-content":"center","align-items":"center"}},[_c('loading')],1)]:_vm._e(),(_vm.loaded)?_c('div',{staticClass:"md-layout"},[_vm._v("\n        test\n    ")]):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c533bfb6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoginError.vue
// module id = null
// module chunks = 